import { render, staticRenderFns } from "./android.vue?vue&type=template&id=ae21d218&scoped=true&"
import script from "./android.vue?vue&type=script&lang=js&"
export * from "./android.vue?vue&type=script&lang=js&"
import style0 from "./android.vue?vue&type=style&index=0&id=ae21d218&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae21d218",
  null
  
)

export default component.exports